import { all } from 'q';

function controller($scope, $routeParams, InvestmentAccountTransfersIn, brand) {
  let userId = $routeParams.clientId;
  if (userId) {
    userId = parseInt(userId, 10);
  } else {
    userId = $scope.$root.auth.currentUser.id;
  }

  $scope.investmentAccountTransferIn = {
    userId,
    category: 'transfer',
    investmentAccountId: null,
    transferInstructions: 'all',
    file: null,
    comment: null,
  };

  $scope.brandFullName = brand.getBrandFullName();

  $scope.requestInvestmentAccountTransferIn = () => {
    $scope.submitting = true;
    InvestmentAccountTransfersIn.create(
      $scope.investmentAccountTransferIn,
      transfer => {
        // If null or VB - both are assumed to be VB, one just has
        // officially been opened yet as it is waiting on VB confirmation
        if (
          (transfer.custodianAlias === null ||
            transfer.custodianAlias === 'VB') &&
          transfer.isGeneratingAgreement
        ) {
          let timeoutCount = 0;
          const poll = setInterval(() => {
            InvestmentAccountTransfersIn.get(
              { id: transfer.id },
              ({ agreementSignatureUrl }) => {
                if (agreementSignatureUrl) {
                  // TODO should actually be after SIGNING the agreements
                  $scope.reviewSignCompleted = true;
                  $scope.agreementGenerated = true;
                  window.location.href = agreementSignatureUrl;
                  clearInterval(poll);
                } else if (timeoutCount >= 120) {
                  $scope.agreementGenerated = false;
                  $scope.submitting = false;
                  $scope.error = true;
                  clearInterval(poll);
                }
              },
              () => {
                // ping error
                clearInterval(poll);
              },
            );

            timeoutCount += 1;
          }, 1000);
        } else {
          window.location.reload();
        }
      },
      error => {
        // transfer creation error
        $scope.error = error;
      },
    );
  };

  $scope.generateAgreement = null;
  $scope.shouldGenerateAgreement = () => {
    if (!!$scope.investmentAccountTransferIn.investmentAccountId === false) {
      return ($scope.generateAgreement = false);
    }
    const { accountType } = $scope.accounts.find(
      a => a.id === $scope.investmentAccountTransferIn.investmentAccountId,
    );
    // controls UI as to wether to display text a vs b.
    // Actual handing of request is done server side.
    $scope.generateAgreement =
      [
        'rrsp',
        'spousal',
        'lira',
        'tfsa',
        'basic',
        'rrif',
        'spousal_rrif',
        'lrif',
      ].includes(accountType) &&
      $scope.investmentAccountTransferIn.transferInstructions === 'all';

    return $scope.generateAgreement;
  };

  return $scope;
}

export default [
  '$scope',
  '$routeParams',
  'InvestmentAccountTransfersIn',
  'brand',
  controller,
];
